import React, { useContext } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import Swipeable from '@components/Swipeable';
import PreviewComponent from '../PreviewComponent';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const CarruselTemplates:React.FC<IProps> = (props, state:IState) => {

  const { setFiltering, setFiltersTemplates } = useContext(StudioContext);

  const handleViewAll = () => {
    setFiltering(true);
    setFiltersTemplates({oem: [props.OEM.name], platform:[],format:[], offerType:[], templateStatus:[]});
  }

  return (
    <S.Root>
      {
        (props.templates && props.templates.length > 0) &&
        <>
          <S.ViewAllButton
            onClick={handleViewAll}
          >
            VIEW ALL
          </S.ViewAllButton>
          <S.Title>
            {props.OEM.name}
          </S.Title>
          <S.SwipeableContainer>
            <Swipeable
              itemsLength={props.templates && props.templates.length > 0 ? props.templates.length : 0}
              itemWidth={246}
              topArrows={85}
              id={props.OEM.id}
            >
              <TransitionGroup className="group-list">
                { props.templates.map((template, index) => {
                    return (
                      <CSSTransition key={template.id} timeout={600} classNames="item">
                        <PreviewComponent
                          index={index}
                          key={index}
                          item={template}
                          addItem={props.addRecentDesign}
                          id={`preview-component-${index}-${props.OEM.id}`}
                          showMetadata={true}
                        />
                      </CSSTransition>
                    )
                  })
                }
              </TransitionGroup>
            </Swipeable>
          </S.SwipeableContainer>
        </>
      }
    </S.Root>
  );
}

export default CarruselTemplates;